import React, { useContext as useContextCore } from 'react'

const context = React.createContext({})
const CoreProvider = context.Provider

export const ContextMenuProvider = ({ children, ...props }) => {
  return <CoreProvider value={{ ...props }}>{children}</CoreProvider>
}

export const useContextMenuContext = () => useContextCore(context)
